import Cloud1 from "../../icons/Cloud1";
import Cloud2 from "../../icons/Cloud2";
import styles from "./styles.module.css";
import heartImage from "../../../assets/adhd/heart.webp"

const Background = ({ children }) => {
  return (
    <div className={styles.Background2}>
      <div className={styles.Cloud1}>
        <Cloud1 />
      </div> 
      <div className={styles.Cloud2}>
        <Cloud2 />
      </div> 
      {children}
    </div>
  );
};

const Background2 = ({ children }) => {
  return (
    <div className={styles.Background2}>
      {/* <img src={heartImage} alt="heart" className={styles.HeartBackground}/> */}
      {children}
    </div>
  );
};

const Background3 = ({ children }) => {
  return (
    <div className={styles.Background3}>
        <div className={styles.Cloud1}>
          <Cloud1 />
        </div> 
        <div className={styles.Cloud2}>
          <Cloud2 />
        </div> 
        <div style={{position: "relative", zIndex: 2}}>
          {children}
        </div>
    </div>
  );
};

const BackgroundIC = ({ backgroundImage, children }) => {
  return (
    <div className={styles.Background3} style={{backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'}}>
        <div style={{position: "relative", zIndex: 2}}>
          {children}
        </div>
    </div>
  );
};


const Background4 = ({ children }) => {
  return (
    <div className={styles.Background4}>
      {/* <img src={heartImage} alt="heart" className={styles.HeartBackground}/> */}
      {children}
    </div>
  );
};

export { Background, Background2, Background3, Background4, BackgroundIC };
